var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"32px"}},[_vm._v(" 打开中，请耐心等待... ")])}
var staticRenderFns = []

export { render, staticRenderFns }